<template>
	<div class="main-banner-register-page">
		<managing-section :column-count="2">
			<managing-box title="순서">
				<input-text
					@input="sortKey = $event"
					mode="number"
					:use-minus="true"
					:prop-value="sortKey"
				/>
			</managing-box>
			<managing-box title="메인배너명">
				<input type="text" v-model="bannerTitle" />
				<p class="main-banner-register-page__notice">
					내부 관리를 위한 제목 입력란입니다.(유저에게 미노출)
				</p>
			</managing-box>
			<ManagingBox title="타이틀">
				<TextCounter
					v-model="displayTitle"
					:useTextarea="true"
					:rows="2"
					:useLineLimit="true"
					:maxLength="10"
					:lengthExceptSpacing="true"
				/>
			</ManagingBox>
			<ManagingBox title="디스크립션">
				<TextCounter
					v-model="description"
					:useTextarea="true"
					:rows="2"
					:useLineLimit="true"
					:maxLength="100"
					:lengthExceptSpacing="true"
				/>
			</ManagingBox>
			<ManagingBox title="광고여부">
				<RadioList v-model="isAd" :radioList="isAdList" />
			</ManagingBox>
			<managing-box :title="`신규이미지<br>${imgSize.join(' * ')}`">
				<ImgSelector
					ref="saveImage"
					@change="saveImageObj = $event"
					:use-cancel="true"
					cancel-btn-text="삭제"
					:validation="saveImageValidation"
				/>
			</managing-box>
			<managing-box title="링크종류">
				<select class="select" v-model="linkType">
					<option
						v-for="item in linkTypeList"
						:key="item.id"
						:value="item.id"
					>
						{{ item.name }}
					</option>
				</select>
			</managing-box>
			<managing-box title="링크값">
				<input type="text" v-model="linkValue" />
			</managing-box>
			<managing-box title="기간">
				<form
					id="main-banner-register-date-range"
					@submit.prevent="register"
				>
					<DateRange v-model="datePeriod" ref="datePeriod" />
				</form>
			</managing-box>
		</managing-section>
		<div class="btn-wrap-main">
			<button
				form="main-banner-register-date-range"
				type="submit"
				class="btn-main blue"
				v-text="'등록'"
			/>
			<button
				type="button"
				class="btn-main"
				v-text="'다시작성'"
				@click="rewrite"
			/>
		</div>
	</div>
</template>

<script>
	import moment from 'moment';
	import { getS3Url, uploadS3, isLinkValueRequired } from '@/util.js';
	import { mapState, mapGetters } from 'vuex';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import InputText from '@/components/InputText.vue';
	import ImgSelector from '@/components/ImgSelector.vue';
	import DateRange from '@/components/DateRange';
	import TextCounter from '@/components/TextCounter.vue';
	import RadioList from '@/components/RadioList.vue';

	export default {
		name: 'MainBannerRegister',
		components: {
			ManagingSection,
			ManagingBox,
			InputText,
			ImgSelector,
			DateRange,
			TextCounter,
			RadioList,
		},
		data() {
			const isAdList = [
				{ id: false, value: 'N' },
				{ id: true, value: 'Y' },
			];

			return {
				sortKey: 0,
				bannerTitle: '',
				saveImageObj: null,
				linkType: null,
				linkValue: '',
				datePeriod: { from: '', to: '' },
				displayTitle: '',
				description: '',
				isAdList,
				isAd: isAdList[0].id,
				imgSize: [1125, 900],
			};
		},
		computed: {
			...mapState({
				IMAGE_STORAGE_PATH: state => state.env.IMAGE_STORAGE_PATH,
			}),
			...mapGetters(['getListAddNull']),
			linkTypeList() {
				return this.getListAddNull('newLinkType');
			},
		},
		methods: {
			validate() {
				if (isNaN(parseInt(this.sortKey))) {
					alert('정렬순서를 입력하세요.');
					return false;
				}
				if (!this.bannerTitle) {
					alert('배너명을 입력하세요.');
					return false;
				}
				if (this.saveImageObj === null) {
					alert('사진을 추가하세요.');
					return false;
				}
				if (!this.linkType) {
					alert('링크종류을 선택하세요.');
					return false;
				}
				if (!this.linkValue && isLinkValueRequired(this.linkType)) {
					alert('링크값을 입력하세요.');
					return false;
				}
				if (!this.datePeriod.from) {
					alert('시작일을 입력하세요.');
					return false;
				}
				if (!this.datePeriod.to) {
					alert('종료일를 입력하세요.');
					return false;
				}
				if (
					moment(this.datePeriod.from).valueOf() >
					moment(this.datePeriod.to).valueOf()
				) {
					alert('종료일시는 시작일시보다 빠를수 없습니다.');
					return false;
				}

				return true;
			},
			async getImgUrl(obj) {
				try {
					const { data } = await getS3Url(
						obj.extension,
						'main_banner'
					);
					await uploadS3(data, obj.fileObj);
					return `${this.IMAGE_STORAGE_PATH}/${data.fields.key}`;
				} catch (err) {
					console.error(err);
					alert(
						'이미지를 등록하는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			async register() {
				try {
					this.$store.commit('toggleSpinner', true);
					if (!this.validate()) return;
					const params = {
						sortKey: this.sortKey,
						bannerType: 'MAIN',
						bannerTitle: this.bannerTitle,
						linkType: this.linkType,
						linkValue: this.linkValue,
						startDate: moment(
							this.datePeriod.from,
							'YYYY-MM-DDTHH:mm'
						).format('YYYYMMDDHHmmss'),
						endDate: moment(
							this.datePeriod.to,
							'YYYY-MM-DDTHH:mm'
						).format('YYYYMMDDHHmmss'),
						saveImageUrl: await this.getImgUrl(this.saveImageObj),
						displayTitle: this.displayTitle,
						description: this.description,
						isAd: this.isAd,
					};
					await this.$axiosAdmin2.post('/api/banner', params);
					this.$router.push('/advertisement/main-banner-manage');
				} catch (err) {
					console.error(err);
					alert(
						'메인배너를 등록하는데 실패했습니다. 개발팀에 문의하세요.'
					);
				} finally {
					this.$store.commit('toggleSpinner', false);
				}
			},
			rewrite() {
				this.$refs.saveImage.init();
				this.sortKey = 0;
				this.bannerTitle = '';
				this.linkType = null;
				this.linkValue = '';
				this.datePeriod = { from: '', to: '' };
				this.displayTitle = '';
				this.description = '';
				this.isAd = this.isAdList[0].id;
			},
			saveImageValidation(imgObj) {
				if (!Array.isArray(this.imgSize)) return false;
				if (this.imgSize[0] !== imgObj.naturalWidth) {
					alert(`이미지 가로사이즈 ${this.imgSize[0]}px!`);
					return false;
				}
				if (this.imgSize[1] !== imgObj.naturalHeight) {
					alert(`이미지 세로사이즈 ${this.imgSize[1]}px!`);
					return false;
				}
				return true;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.main-banner-register-page__notice {
		margin-top: 10px;
	}
</style>
